import './css/Cursos.css';
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { useEffect , useState} from "react";
import Espera from '../Espera';
import { QRCodeSVG } from 'qrcode.react'; // Importa la biblioteca QR Code
import CONFIG from '../../config';
import PerfilLogo from '../usuarios/PerfilLogo';
import MostrarEnMuro from './MostrarEnMuro';

const URL  = `${CONFIG.API_URL}/operarCursos.php`;
const URL_MURO  = `${CONFIG.API_URL}/operarRegistros.php`;
const URL_PLATAFORMA =`${CONFIG.BASE_URL}`;

function MiCurso({acceder, rol, configuracion}) {
    const { idMC } = useParams();
    const navigate = useNavigate();
    const loggeduserCursoGrupoO =JSON.parse(localStorage.getItem('loggeduserCursoGrupoO'));
    const loggeduserClasesCurso =localStorage.getItem('loggeduserClasesCurso');
    const loggedUserId =JSON.parse(localStorage.getItem('loggedUserId'));

    const [curso, setCurso] = useState(loggeduserCursoGrupoO);
    const [clases, setClases] = useState([]);
    const [registros, setRegistros] = useState([]);

    const [espera, setEspera] = useState(false);

    const loggeduserCurso =localStorage.getItem('loggeduserCurso');
    const loggeduserCursoGrupo =localStorage.getItem('loggeduserCursoGrupo');
    
    
    const data= {
        'id_curso' : idMC,
        'id_grupo' : loggeduserCursoGrupo,
        'modo': 'buscarClasesCursoUsuario'
    }
    
    useEffect(() => {
        
        if(acceder){
            if((rol===null) || (rol<5)){
                navigate("/");
            }else{
                //si no tiene codigo inscripcion lo generao
                curso.codigo_inscripcion === ''&& generarQRCode(curso.id_curso_grupo);
                buscarRegistrosCurso();
                if(idMC===loggeduserCurso){
                    //console.log('loggeduserClasesCurso: '+loggeduserClasesCurso);
                    //verifico que no tenga las calses almacenadas en localstorage asi no repito la API
                    if((!loggeduserClasesCurso) || (loggeduserClasesCurso==null)){ 
                       // console.log('entro en if, data:'+JSON.stringify(data));
                        buscaClasesCurso(data);
                    }else{
                       // console.log('no entro en if');
                        const parse = JSON.parse(loggeduserClasesCurso);
                        parse.sort((a, b) => b.id - a.id);
                        localStorage.setItem('loggeduserClasesCurso',  JSON.stringify(parse));
                        setClases(parse);
                        //console.log('parse:'+JSON.stringify(parse));
                    }
                }else{
                    navigate(`/principal`);
                }
            }
        }else{
            localStorage.clear();
            navigate('/');
        }
        //console.log("cursoooo:"+clases);
    }, []);
    
    const buscarRegistrosCurso = () =>{
        setEspera(true);
        axios.get(`${URL_MURO}?id_curso_grupo=${loggeduserCursoGrupo}`)
        .then(res =>{
            //console.log("registros:"+JSON.stringify(res.data));
            if(!res.data.error){   
                setRegistros(res.data.registros);
            }else{
                setRegistros([]);
            }
            setEspera(false);           
        })
        .catch(err=>{
            console.log(err);
        })   

    }
    const buscaClasesCurso =  (d) =>{
        setEspera(true);
        axios.post(URL, d)
        .then(res =>{
          //  console.log("cursoooo:"+JSON.stringify(res.data));
            if(!res.data.error){   
                //setCurso(res.data.curso);
                setClases(res.data.sort((a, b) => b.id - a.id))
                localStorage.setItem('loggeduserClasesCurso',  JSON.stringify(res.data));
                
               //console.log("cursos:"+curso);
            }else{
               // setCurso([]);
                setClases([]);
            }
            setEspera(false);           
        })
        .catch(err=>{
            console.log(err);
        })   
    }

    const generarQRCode = async (id_curso_grupo) => {
        const data = {
            id_curso_grupo: id_curso_grupo,
            modo:'generarCodigoInscripcion'
        };
        try {
            const res = await axios.post(URL, data)
            const [tipo, msj, codigo] = res.data;
            if (tipo === 'success') {
             //   obtenerDatosCursos();
             //   setQrCode(codigo)
             curso.codigo_inscripcion=codigo;
             console.log(curso.codigo_inscripcion)
            }
        } catch (err) {
            //show_alerta('Error en la solicitud', 'error');
        }
    };
    const formatearFechaCompleta = (fechaString) =>{
        if (!fechaString) return '';

        const fecha = new Date(fechaString.replace(" ", "T"));
        const opcionesFecha = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };

        const opcionesHora = {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        };

        // Función para capitalizar la primera letra
        const capitalizar = (texto) => texto.charAt(0).toUpperCase() + texto.slice(1);

        const fechaFormateada = fecha.toLocaleDateString('es-AR', opcionesFecha);
        const horaFormateada = fecha.toLocaleTimeString('es-AR', opcionesHora);

      return `${capitalizar(fechaFormateada)} ${horaFormateada}hs`;
    }
    const mostrarNombre = (orden)=>{
        switch(orden){
          case "S2": return 'Sala 2 años';
          case "S3": return 'Sala 3 años';
          case "S4": return 'Sala 4 años';
          case "S5": return 'Sala 5 años';
          case "In": return 'Espacio Institucional';
          default: return orden+'°';
        }
    };
    return ( 
        <div className="container-principal"> 
            <div className='contenedor-micurso'>
                <div className="portada-curso" style={{border: `1px solid ${configuracion.color_secundario}`}}>
                    <img 
                    src={`${CONFIG.API_URL}/${
                        curso.imagen_grupo_curso?.trim() || 
                        curso.imagen?.trim() || 
                        curso.imagen_general?.trim() || 
                        curso.caratula_formacion?.trim() || 
                        `img/${configuracion.imagen_fondo}`
                    }`} 
                    className="card-img-top " 
                    alt='imagen-decorativa'
                    />    
                    <h3 style={{backgroundColor: configuracion.color_secundario,color: configuracion.color_terciario}}>
                        {curso.tipo_formacion!=7
                        ? <>
                            <span className='small'>{mostrarNombre(curso.orden)} | </span> 
                            {curso.nombre.toLowerCase().includes('años')
                            ? 'General'
                            : curso.nombre_espacio
                            }
                        </>
                        :' '
                        }
                    </h3>
                    <h4 style={{backgroundColor: configuracion.color_secundario,color: configuracion.color_terciario}}>
                        Grupo {curso.denominacion}
                    </h4>
                    <h5>id.: {curso.id}-{curso.id_curso_grupo}</h5>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        {(rol==6 || rol==5) &&
                        <div className="accordion my-2" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button text-center" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Codigo de inscripcion
                                    </button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse " data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        <div className='row'>
                                            <div className='col-12 col-sm-3'>
                                                <div className='card mt-1'>
                                                    <div className="card-body d-flex justify-content-center">
                                                        <QRCodeSVG value={`${URL_PLATAFORMA}inscripcion/${curso.codigo_inscripcion}`} size={128} />
                                                    </div>   
                                                    <div className='d-flex justify-content-center'>
                                                        <h3>{curso.codigo_inscripcion}</h3>
                                                    </div>                     
                                                </div>
                                            </div>
                                            <div className='col-12 col-sm-9'>
                                            <strong>Este código de inscripción alfanumérico</strong> será requerido cuando se realiza la inscripción a la plataforma de manera auto asistida.
                                                En tanto <strong>el código QR </strong> podrá ser escaneado con un dispositivo móvil para dirigirse directamente al formulario de registro con el código ya precargado en el mismo.
                                            </div>
                                        </div>
                                        
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        {rol==1 && 
                            <button 
                                type='button' 
                                className='btn-csi2' 
                                onClick={() => navigate(`/MC/${curso.id}/IA/${curso.id_curso_grupo}`)}
                               style={{
                                    '--btn-bg': configuracion.color_terciario,
                                    '--btn-border': configuracion.color_secundario,
                                    '--btn-color': configuracion.color_secundario,
                                }}
                            >
                                <i className="fa-solid fa-brain"></i> Generador de Plan de Curso asistido con IA
                            </button>
                        }
                        <button 
                            className="btn-csi2"
                            type="button" onClick={() => navigate(`/MC/${curso.id}/P/${curso.id_curso_grupo}`)}
                            style={{
                                '--btn-bg': configuracion.color_terciario,
                                '--btn-border': configuracion.color_secundario,
                                '--btn-color': configuracion.color_secundario,
                            }} 
                        >
                            <i className="fa-solid fa-list-check"></i> Planificacion
                        </button>
                    </div>
                </div>
                
                <div className="d-grid gap-2 mt-4 mb-4">
                    {!espera ? 
                    <>
                    <div className='alert alert-info'>Bienvenido/a {curso.orden.startsWith('S') ? 'a la Sala de ' : 'al curso'} {curso.nombre}</div>
                        {registros.length===0 && <div className='card p-2 mb-2'>No hay actividad  en el muro</div>}

                        {registros.length>0 && registros.map((reg)=>(
                        <>
                            
                            <div key={reg.id} className='text-secondary-emphasis bg-light-subtle border border-secondary-subtle rounded-3 shadow-sm p-1 px-2 mb-1'>    
                                <div className='row  mx-1 mb-2'>
                                    {reg.creado_por !=0 &&
                                    <div className=''>
                                            <PerfilLogo id={reg.creado_por} configuracion={configuracion} version={'muro'} />
                                    </div>
                                    }
                                    <div className=''>
                                        <span className='text-secondary text-lowercase fs-7'>{formatearFechaCompleta(reg.fecha)}</span>
                                    </div>
                                </div>
                               
                                <div className='row'>
                                    <div className='col-12'>
                                        {reg.area=='Inscripción'?
                                        <>
                                        {reg.idElemento==loggedUserId?
                                            <h6>
                                                <i className="text-success px-2 fa-solid fa-user-graduate"></i>
                                                <span>Se te agrego al curso</span>
                                            </h6>
                                        :
                                        <>
                                            <div className='small'>
                                                <i className="text-success px-2 fa-solid fa-user-graduate"></i>
                                                {reg.detalle}
                                            </div>
                                            <div className='d-flex justify-content-start mb-2'>
                                                <PerfilLogo id={reg.idElemento} configuracion={configuracion} version={'muro'} />
                                            </div>
                                        </>
                                        }
                                        </>
                                        :
                                        <h6 className="px-4 hacer-link" onClick={()=>navigate(`/MC/${curso.id}/c/${reg.id}`)}>
                                            <MostrarEnMuro area={reg.area} detalle={reg.detalle} idElemento={reg.idElemento} />
                                        </h6>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                        ))
                        }

                    </>
                        : <div className='container m-3'><Espera visible={espera} /></div>
                        }               
                </div>
            </div>
        </div> 
    );
}

export default MiCurso;